import logo from './logo.svg';
import './App.css';
import GameComponent from './components/game_component';

function App() {
  return (
    <div className="App">
      <GameComponent/>
    </div>
  );
}

export default App;
